export default "__VITE_ASSET__Cid7kuH1__"